import { ajaxAuth } from "@tm/utils"
import { WebserviceUrl } from "../../webserviceUrls"
import { ArticlesDeleteRequest } from ".."

export async function deleteArticlesEmbedded(body: ArticlesDeleteRequest) {
    const url = `${WebserviceUrl.CompilationsArticleCompilationsEmbedded}/ArticlesDelete`

    return ajaxAuth({ url, body, method: "POST" })
}
